// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_3G6","cls2":"Search-cls2_ndF Search-cls1_3G6"};